module.exports = __webpack_public_path__ + "img/breviary2.dbb617db.jpg";